export default function loadScript(src: string) {
	return new Promise((resolve) => {
		const script = document.createElement('script');
		script.onload = resolve;
		script.src = src;
		document.head.appendChild(script);
	});
}
